export default __webpack_public_path__ + "static/spark-3d105b54cd5468f3915de9cad606f3a5.png";